import React from 'react';
import { motion } from 'framer-motion';

export const DeliverBuildIcon: React.FC<{ isActive: boolean }> = ({
	isActive,
}) => {
	return (
		<motion.svg
			animate={isActive ? { scale: 1.2 } : null}
			width="100%"
			height="100%"
			viewBox="0 0 66 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="1.24664"
				y="0.00214201"
				width="29.9783"
				height="29.9783"
				rx="1.25"
				transform="matrix(0.83205 -0.5547 0.830139 0.557556 7.88533 41.6163)"
				fill="white"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linejoin="round"
			/>
			<rect
				x="1.24664"
				y="0.00214201"
				width="29.9783"
				height="29.9783"
				rx="1.25"
				transform="matrix(0.83205 -0.5547 0.830139 0.557556 7.88533 32.2237)"
				fill="white"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linejoin="round"
			/>
			<rect
				x="1.24664"
				y="0.00214201"
				width="29.9783"
				height="29.9783"
				rx="1.25"
				transform="matrix(0.83205 -0.5547 0.830139 0.557556 7.85603 22.794)"
				fill="white"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linejoin="round"
			/>
			<path
				d="M40.5974 17.8122L40.901 18.0737L41.3923 18.0369L44.805 17.7816L46.1243 21.0424L42.9842 21.9164L42.5133 22.0475L42.4492 22.3862C42.3463 22.9296 42.1664 23.4314 41.8517 23.9411L41.6594 24.2525L41.9631 24.5218L44.0306 26.3555L40.4824 28.7209L37.7498 27.3306L37.3421 27.1232L36.8712 27.2571C36.131 27.4675 35.3783 27.5804 34.5564 27.648L34.0501 27.6896L33.8525 28.0042L32.5347 30.1022L27.6665 29.2072L28.0607 26.9246L28.1175 26.596L27.7279 26.3919C27.3966 26.2183 27.0937 26.0485 26.8145 25.861C26.5345 25.6729 26.2718 25.4627 25.992 25.2252L25.685 24.9647L25.1932 25.0045L21.8166 25.2774L20.4975 22.0172L23.6311 21.1364L24.0928 21.0067L24.1618 20.6746C24.2758 20.1263 24.4479 19.6216 24.7656 19.1265L24.9675 18.8119L24.6589 18.5383L22.5914 16.7046L26.1396 14.3391L28.8722 15.7294L29.2799 15.9369L29.7508 15.803C30.4919 15.5923 31.2469 15.479 32.0667 15.4047L32.5631 15.3598L32.7588 15.0513L34.0866 12.9578L38.9539 13.8525L38.5335 16.111L38.4723 16.4399L38.8604 16.6463C39.2142 16.8344 39.5275 17.011 39.8075 17.1991C40.0867 17.3866 40.3392 17.5899 40.5974 17.8122ZM20.305 22.0713L20.3084 22.0703L20.305 22.0713ZM33.3239 25.2767C34.8091 25.2843 36.2336 24.8966 37.2824 24.1974C38.3313 23.4982 38.9159 22.5464 38.9101 21.5526C38.9044 20.559 38.3092 19.6048 37.2579 18.8987C36.2067 18.1927 34.7829 17.7909 33.2981 17.7833C31.8129 17.7758 30.3884 18.1634 29.3396 18.8626C28.2907 19.5619 27.7061 20.5137 27.7119 21.5075C27.7176 22.501 28.3128 23.4552 29.3641 24.1613C30.4153 24.8674 31.8391 25.2692 33.3239 25.2767Z"
				fill="#F27C00"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
		</motion.svg>
	);
};
